module.exports = __webpack_public_path__ + "img/menu-appeal.c88f71d.svg";